import _ from 'lodash';
import ObjectScan from "utils/objects/scan";
import ObjectClass from 'utils/objects/object'
import { dataConstants } from 'services/redux/data/constants'
import store from 'services/redux/store'
import { constantsActive } from 'utils/constants/constants'
import { settingsOptions } from 'utils/constants/settings-constants'
import HelperDate from 'utils/helper-date'

const ObjectEmployee = {
	
	defaults: {
		active: constantsActive.YES,
		response_employee: constantsActive.NO,
	},
	
	byGuid: ( object ) => {
		const guid = _.get( object,  ['guid'], null );
		if( guid !== null ) {
			return object;
		}
		
		return null;
	},
	
	/**
	 *
	 * @param objects
	 * @returns {unknown[]}
	 */
	filter: ( objects ) => {
		return ObjectClass.filterActive( objects )
	},
	
	/**
	 *
	 * @param objects
	 * @returns {{}}
	 */
	filterInvisible: ( objects ) => {
		let values = {};
		
		_.forEach( objects, ( value, key ) => {
			if( _.get( value, 'active', settingsOptions.YES ) === settingsOptions.YES && _.get( value, 'visible_for_employees', settingsOptions.YES ) === settingsOptions.YES && value.name !== '[hidden]' ) {
				values[ key ] = value;
			}
		})
		
		return { ...values }
	},
	
	/**
	 * Sort the employees by name
	 * @param objects
	 * @returns {objects[]}
	 */
	order: ( objects ) => {
		return _.orderBy( objects, 'name', 'asc' )
	},
	
	/**
	 * Remove inactive employees and sort by name
	 * @param objects
	 * @returns {objects[]}
	 */
	filterAndOrder: ( objects ) => {
		return ObjectEmployee.order( ObjectEmployee.filter( objects ) );
	},
	
	/**
	 *
	 * @param employee
	 * @returns {unknown[]}
	 */
	getScans: ( employee ) => {
		return _.filter( _.get( employee, 'scans', [] ), o => {
			return HelperDate.fn.isToday( HelperDate.date( o.scanned_in_at ) )
		});
	},
	
	/**
	 * Check if the employee is present by employee object
	 * @param employee
	 * @returns {boolean}
	 */
	isPresent: ( employee ) => {
		const scans = _.get( employee, 'scans', [] );
		let isPresent = false;
		
		_.forEach( scans, scan => {
			if( !isPresent ) {
				isPresent = ObjectScan.isPresent( scan );
			}
		});
		
		return isPresent;
	},
	
	/**
	 * Simple function for checking if employee is on-d-mand
	 * @param employee
	 * @returns {boolean}
	 */
	isOndmand: ( employee ) => {
		const email = _.get( employee, 'email', '' );
		if( typeof email === 'string' ) {
			return email.indexOf( '@on-d-mand.nl' ) !== -1;
		}
		
		return false;
	},
	
	/**
	 *
	 * @param employee
	 */
	isAdmin: ( employee ) => {
		return !_.isEmpty( _.get( employee, 'user', {} ) );
	},
	
	/**
	 *
	 * @param employee
	 * @returns {*}
	 */
	isScanner: ( employee ) => {
		return (employee?.name ?? '').startsWith( 'scanner' )
	},
	
	/**
	 *
	 */
	getLoggedIn: () => {
		const employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		return !_.isEmpty( employee ) ? employee : false
	},
	
	/**
	 *
	 */
	mayOverlap: ( ...check ) => {
		const employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		const bookingsMayOverlap = _.get( employee, 'bookings_may_overlap', '' );
		if( _.isEmpty( bookingsMayOverlap ) ) {
			return false;
		}
		
		let mayOverlap = false;
		const bookingsMayOverlapList = bookingsMayOverlap.split(',')
		_.forEach( check, o => {
			if( _.includes( bookingsMayOverlapList, o ) ) {
				mayOverlap = true;
			}
		})
		
		return mayOverlap;
	}
}

export default ObjectEmployee
